const styles = theme => ({
  bedsAvailabilityRoot: {
    display: 'grid',
    paddingTop: '20px',
    gridTemplateRows: '20px 90px 1fr 60px 60px',
    gridTemplateColumns: '30px 1fr 30px',
    minHeight: '400px',
    alignItems: 'flex-start',
    maxHeight: 'calc(100vh - 100px)'
  },
  currentDate: {
    gridRow: '1',
    gridColumn:'1 / span 3',
    alignItems: 'stretch',
    paddingLeft: '15px',
    
  },

  chartWrapper: {
    gridRow: '3',
    gridColumn: '2',
    justifyContent: 'center',
    alignItems: 'center',
    margin:'auto 0'
  },
  inputoutputs: {
    gridRow: '4',
    gridColumn: '1 / span 3',
    height: '60px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  input:{
    width:"100%",
    textAlign:"center"
  },
  freeBedsCount: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gridRow: '2',
    gridColumn: '1 / span 3',
    textAlign: 'center',
  },

  overBedsCountNumber: {
    color: '#FF3333',
  },
  claimsCountNumber: {
    color: '#800080',
    fontWeight: 'bold'
  },
  freeBedsCountNumber: {
   fontSize:32 
   //color: '#029AB1',
  },

  footer: {
    gridRow: '5',
    gridColumn: '1 / span 3',
    height: '60px'
  },
});

export default styles;
